/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuditDTO,
  AuditDTOQueryResultDTO,
  AuditGetAuditLogsListParams,
  AuditGetAuditLogsParams,
  AuditGetEntityAuditHistoryParams,
  FilterModelDTO,
  QueryColumnConfigDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





/**
 * @summary Get audit logs with pagination
 */
export const auditGetAuditLogs = (
    params?: AuditGetAuditLogsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AuditDTOQueryResultDTO>(
      {url: `/api/site-admin/Audit`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAuditGetAuditLogsQueryKey = (params?: AuditGetAuditLogsParams,) => {
    return [`/api/site-admin/Audit`, ...(params ? [params]: [])] as const;
    }

    
export const getAuditGetAuditLogsQueryOptions = <TData = Awaited<ReturnType<typeof auditGetAuditLogs>>, TError = ErrorType<unknown>>(params?: AuditGetAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLogs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditGetAuditLogsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditGetAuditLogs>>> = ({ signal }) => auditGetAuditLogs(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditGetAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof auditGetAuditLogs>>>
export type AuditGetAuditLogsQueryError = ErrorType<unknown>


export function useAuditGetAuditLogs<TData = Awaited<ReturnType<typeof auditGetAuditLogs>>, TError = ErrorType<unknown>>(
 params: undefined |  AuditGetAuditLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditGetAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof auditGetAuditLogs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditGetAuditLogs<TData = Awaited<ReturnType<typeof auditGetAuditLogs>>, TError = ErrorType<unknown>>(
 params?: AuditGetAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditGetAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof auditGetAuditLogs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditGetAuditLogs<TData = Awaited<ReturnType<typeof auditGetAuditLogs>>, TError = ErrorType<unknown>>(
 params?: AuditGetAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLogs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get audit logs with pagination
 */

export function useAuditGetAuditLogs<TData = Awaited<ReturnType<typeof auditGetAuditLogs>>, TError = ErrorType<unknown>>(
 params?: AuditGetAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLogs>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditGetAuditLogsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get audit logs with pagination and filtering
 */
export const auditGetAuditLogsList = (
    filterModelDTO: FilterModelDTO[],
    params?: AuditGetAuditLogsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AuditDTOQueryResultDTO>(
      {url: `/api/site-admin/Audit/list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: filterModelDTO,
        params, signal
    },
      );
    }
  


export const getAuditGetAuditLogsListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof auditGetAuditLogsList>>, TError,{data: FilterModelDTO[];params?: AuditGetAuditLogsListParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof auditGetAuditLogsList>>, TError,{data: FilterModelDTO[];params?: AuditGetAuditLogsListParams}, TContext> => {
    
const mutationKey = ['auditGetAuditLogsList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof auditGetAuditLogsList>>, {data: FilterModelDTO[];params?: AuditGetAuditLogsListParams}> = (props) => {
          const {data,params} = props ?? {};

          return  auditGetAuditLogsList(data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuditGetAuditLogsListMutationResult = NonNullable<Awaited<ReturnType<typeof auditGetAuditLogsList>>>
    export type AuditGetAuditLogsListMutationBody = FilterModelDTO[]
    export type AuditGetAuditLogsListMutationError = ErrorType<unknown>

    /**
 * @summary Get audit logs with pagination and filtering
 */
export const useAuditGetAuditLogsList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof auditGetAuditLogsList>>, TError,{data: FilterModelDTO[];params?: AuditGetAuditLogsListParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof auditGetAuditLogsList>>,
        TError,
        {data: FilterModelDTO[];params?: AuditGetAuditLogsListParams},
        TContext
      > => {

      const mutationOptions = getAuditGetAuditLogsListMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Get audit log filter configuration
 */
export const auditGetAuditLogFilterConfig = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<QueryColumnConfigDTO[]>(
      {url: `/api/site-admin/Audit/filter-config`, method: 'GET', signal
    },
      );
    }
  

export const getAuditGetAuditLogFilterConfigQueryKey = () => {
    return [`/api/site-admin/Audit/filter-config`] as const;
    }

    
export const getAuditGetAuditLogFilterConfigQueryOptions = <TData = Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditGetAuditLogFilterConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>> = ({ signal }) => auditGetAuditLogFilterConfig(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditGetAuditLogFilterConfigQueryResult = NonNullable<Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>>
export type AuditGetAuditLogFilterConfigQueryError = ErrorType<unknown>


export function useAuditGetAuditLogFilterConfig<TData = Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>,
          TError,
          Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditGetAuditLogFilterConfig<TData = Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>,
          TError,
          Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditGetAuditLogFilterConfig<TData = Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get audit log filter configuration
 */

export function useAuditGetAuditLogFilterConfig<TData = Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLogFilterConfig>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditGetAuditLogFilterConfigQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get audit log by ID
 */
export const auditGetAuditLog = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AuditDTO>(
      {url: `/api/site-admin/Audit/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getAuditGetAuditLogQueryKey = (id: number,) => {
    return [`/api/site-admin/Audit/${id}`] as const;
    }

    
export const getAuditGetAuditLogQueryOptions = <TData = Awaited<ReturnType<typeof auditGetAuditLog>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLog>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditGetAuditLogQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditGetAuditLog>>> = ({ signal }) => auditGetAuditLog(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditGetAuditLogQueryResult = NonNullable<Awaited<ReturnType<typeof auditGetAuditLog>>>
export type AuditGetAuditLogQueryError = ErrorType<unknown>


export function useAuditGetAuditLog<TData = Awaited<ReturnType<typeof auditGetAuditLog>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditGetAuditLog>>,
          TError,
          Awaited<ReturnType<typeof auditGetAuditLog>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditGetAuditLog<TData = Awaited<ReturnType<typeof auditGetAuditLog>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditGetAuditLog>>,
          TError,
          Awaited<ReturnType<typeof auditGetAuditLog>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditGetAuditLog<TData = Awaited<ReturnType<typeof auditGetAuditLog>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLog>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get audit log by ID
 */

export function useAuditGetAuditLog<TData = Awaited<ReturnType<typeof auditGetAuditLog>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetAuditLog>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditGetAuditLogQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get audit logs for a specific entity
 */
export const auditGetEntityAuditHistory = (
    tableName: string,
    primaryKey: string,
    params?: AuditGetEntityAuditHistoryParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AuditDTOQueryResultDTO>(
      {url: `/api/site-admin/Audit/entity/${tableName}/${primaryKey}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAuditGetEntityAuditHistoryQueryKey = (tableName: string,
    primaryKey: string,
    params?: AuditGetEntityAuditHistoryParams,) => {
    return [`/api/site-admin/Audit/entity/${tableName}/${primaryKey}`, ...(params ? [params]: [])] as const;
    }

    
export const getAuditGetEntityAuditHistoryQueryOptions = <TData = Awaited<ReturnType<typeof auditGetEntityAuditHistory>>, TError = ErrorType<unknown>>(tableName: string,
    primaryKey: string,
    params?: AuditGetEntityAuditHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetEntityAuditHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditGetEntityAuditHistoryQueryKey(tableName,primaryKey,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditGetEntityAuditHistory>>> = ({ signal }) => auditGetEntityAuditHistory(tableName,primaryKey,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tableName && primaryKey), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditGetEntityAuditHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditGetEntityAuditHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof auditGetEntityAuditHistory>>>
export type AuditGetEntityAuditHistoryQueryError = ErrorType<unknown>


export function useAuditGetEntityAuditHistory<TData = Awaited<ReturnType<typeof auditGetEntityAuditHistory>>, TError = ErrorType<unknown>>(
 tableName: string,
    primaryKey: string,
    params: undefined |  AuditGetEntityAuditHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetEntityAuditHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditGetEntityAuditHistory>>,
          TError,
          Awaited<ReturnType<typeof auditGetEntityAuditHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditGetEntityAuditHistory<TData = Awaited<ReturnType<typeof auditGetEntityAuditHistory>>, TError = ErrorType<unknown>>(
 tableName: string,
    primaryKey: string,
    params?: AuditGetEntityAuditHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetEntityAuditHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditGetEntityAuditHistory>>,
          TError,
          Awaited<ReturnType<typeof auditGetEntityAuditHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditGetEntityAuditHistory<TData = Awaited<ReturnType<typeof auditGetEntityAuditHistory>>, TError = ErrorType<unknown>>(
 tableName: string,
    primaryKey: string,
    params?: AuditGetEntityAuditHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetEntityAuditHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get audit logs for a specific entity
 */

export function useAuditGetEntityAuditHistory<TData = Awaited<ReturnType<typeof auditGetEntityAuditHistory>>, TError = ErrorType<unknown>>(
 tableName: string,
    primaryKey: string,
    params?: AuditGetEntityAuditHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditGetEntityAuditHistory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditGetEntityAuditHistoryQueryOptions(tableName,primaryKey,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



